import Card from "@mui/material/Card";
import Divider from "@mui/material/Divider";

import MDBox from "./MDBox";
import MDTypography from "./MDTypography";

const _ = ({ color, icon, title, description, value }) => {
  return (
    <Card>
      <MDBox p={2} mx={3} display="flex" justifyContent="center">
        <MDBox
          display="grid"
          justifyContent="center"
          alignItems="center"
          bgColor={color}
          color="white"
          width="4rem"
          height="4rem"
          shadow="md"
          borderRadius="lg"
          variant="gradient"
        >
          {icon}
        </MDBox>
      </MDBox>
      <MDBox pb={2} px={2} textAlign="center" lineHeight={1.25}>
        <MDTypography
          variant="h5"
          fontWeight="medium"
          //textTransform="capitalize"
        >
          {title}
        </MDTypography>
        {description && (
          <MDTypography variant="caption" color="text" fontWeight="regular">
            {description}
          </MDTypography>
        )}
        {description && !value ? null : <Divider />}
        {value && (
          <MDTypography variant="h5" fontWeight="medium">
            {value}
          </MDTypography>
        )}
      </MDBox>
    </Card>
  );
};

// Setting default values for the props of DefaultInfoCard
_.defaultProps = {
  color: "info",
  value: "",
  description: "",
};

export default _;
